<form
    *ngIf="formGroup"
    [formGroup]="formGroup"
    [isEnabled]="isBedSideMode && isActive"
    (ngSubmit)="keyboardEnterClicked($event)"
>
    <div class="app-physical-examination-form__row">
        <mat-form-field
            class="app-input-field app-physical-examination-form__field"
            appearance="fill"
            data-testid="ff-physicalExaminationText"
        >
            <mat-label>{{ 'apps.admission.physicalExamination.textLabel' | translate }}</mat-label>
            <textarea
                [formControl]="formGroup.controls.text"
                required
                matInput
                [cdkAutosizeMaxRows]="textareaMaxRows"
                cdkAutosizeMinRows="2"
                cdkTextareaAutosize
                data-testid="ff-physicalExaminationTextarea"
            ></textarea>
            <mat-error>
                <ui-validation-message [control]="formGroup.controls.text"></ui-validation-message>
            </mat-error>
        </mat-form-field>
    </div>
    <ng-content></ng-content>
</form>
